import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-[580px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20minimalist%20abstract%20geometric%20background%20with%20soft%20flowing%20gradients%20in%20warm%20coral%20and%20amber%20tones%2C%20elegant%20curved%20lines%2C%20modern%20clean%20aesthetic%2C%20digital%20technology%20theme%2C%20soft%20light%20effects%2C%20professional%20atmosphere&width=1800&height=900&seq=hero-bg-aiye-01&orientation=landscape"
          alt="爱液网页版 - 在线服务平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            <span className="text-xs md:text-sm text-white/90 font-medium">V3.0 版本全新上线，五大核心功能升级</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4">
            无需下载安装
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-rose-300">
              即开即用
            </span>
            的在线服务
          </h1>

          <p className="text-sm md:text-base text-white/75 max-w-xl mx-auto mb-8 leading-relaxed">
            爱液网页版是专业的在线服务平台，支持PC端与手机端多端访问。打开浏览器即可使用全部功能，操作简便流畅，随时随地轻松体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/rumen"
              className="px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              立即开始使用
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-medium text-sm border border-white/25 hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              了解更多
            </Link>
          </div>

          <div className="flex items-center justify-center gap-8 mt-12">
            {[
              { value: '500万+', label: '累计用户' },
              { value: '99.9%', label: '服务可用性' },
              { value: '10万+', label: '日均活跃' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}